/*
 * NOTE: Hot reload does work correctly!
 *       While it triggers, the changes might not apply.
 *       Restart manually when changing this file.
 */
const fiwe = {
  brand: '#FF0000',
  'brand-highlight': '#DBD9D4',
  'brand-selected': '#EFEFEC',
  'typo-brand': '#FF0000',
  black: '#000000',
  white: '#FFFFFF',
  grey: '#BDBAB0',
  'grey-20': '#F2F1EF',
  'grey-40': '#E5E3DF',
  'grey-70': '#D0CEC7',
  'grey-dark': '#8C827A',
  enunciate: '#FF0000',
  'box-shadow': 'rgba(0, 0, 0, 0.06)',
  'box-shadow-strong': 'rgba(0, 0, 0, 0.1)',
  'status-error': '#C50000',
  'status-success': '#5DAE00',
  'status-warn': '#FF9E00',
  'status-warn-dark': '#eb8800',
  'status-disabled': '#D0CEC7',
  'typo-black': '#000000',
  'typo-white': '#ffffff',
  'typo-grey-dark': '#8C827A',
  'poi-initial': '#C50000',
  'poi-installed': '#FF9E00',
  'poi-checked': '#5DAE00',
};

export const fiweDark = {};

const fite = {
  ...fiwe,
  brand: '#0069B4',
  'brand-highlight': '#D1E2EE',
  'brand-selected': '#DFEEF8',
  'typo-brand': '#0069b4',
  black: '#242627',
  enunciate: '#FF0000',
  grey: '#96A2A8',
  'grey-20': '#EEF3F5',
  'grey-40': '#DBE2E6',
  'grey-70': '#C2CDD1',
  'grey-dark': '#60676C',
  'typo-grey-dark': '#60676C',
  'status-error': '#DE3535',
  'status-success': '#89D14A',
  'status-warn': '#E3A540',
};

const upat = {
  ...fiwe,
  brand: '#1561AC',
  'typo-brand': '#1561AC',
  enunciate: '#E97300',
};

export default {
  fiwe,
  fite,
  upat,
};
